import { useLocalization } from '@/hooks/useLocalization';
import BotMessage from '@/components/ChatMessage/BotMessage';

export default function CompanyScreen() {
  const { t } = useLocalization();

  return (
    <BotMessage text={t('company.message')} />
  );
}
